export default "__VITE_ASSET__CK0Czc97__"